(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
    function initFiltersToggle() {
      const toggleBtns = document.querySelectorAll('[id^="facets-vertical-toggle--"]');
      toggleBtns.forEach(function (btn) {
        const panelId = btn.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);
        if (!panel) return;

        // Find the closest collection-wrapper
        const wrapper = panel.closest('.collection-wrapper');

        // Set initial state: filters start hidden
        if (wrapper) wrapper.classList.add('filters-panel-hidden');

        btn.addEventListener('click', function () {
          const isExpanded = btn.getAttribute('aria-expanded') === 'true';
          if (isExpanded) {
            btn.setAttribute('aria-expanded', 'false');
            panel.classList.add('hidden');
            if (wrapper) wrapper.classList.add('filters-panel-hidden');
          } else {
            btn.setAttribute('aria-expanded', 'true');
            panel.classList.remove('hidden');
            if (wrapper) wrapper.classList.remove('filters-panel-hidden');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFiltersToggle);
    } else {
      initFiltersToggle();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
